import type {TooltipProps} from '@refra/modules/common/types'

export const Tooltip: React.FC<TooltipProps> = ({text, children}) => {
  return (
    <div className="relative group">
      {children}
      <div
        className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 px-2 py-1 
        bg-gray-900 text-white text-xs rounded whitespace-nowrap
        opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-opacity z-50"
      >
        {text}
        <div className="absolute top-full left-1/2 -translate-x-1/2 border-4 border-transparent border-t-gray-900" />
      </div>
    </div>
  )
}
